import { useState } from "react";
import { registerUser } from "../features/user/userSlice";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux'
import {
  Container,
  Header
} from "semantic-ui-react";

import UserForm from "./UserForm";

function Register(props) {
  const [requestMessage, setRequestMessage] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const onRegisterSubmit = async (user) => {
    const result = await dispatch(registerUser(user)).unwrap();
    if (result.success) {
      navigate("/login");
    } else {
      console.error(result);
      setRequestMessage(result.message);
    }
  };

  return (
    <div>
      <Container text>
        <Header style={{ paddingTop: '20px' }} as="h1">Register</Header>
        <UserForm onSubmit={onRegisterSubmit} requestMessage={requestMessage} isWaiting={props.isWaiting} />
      </Container>
    </div>
  );
}

export default Register;
